export default __webpack_public_path__ + "static/media/3-ENTRAINEUR.d05225de.pdf";